import PropTypes from "prop-types";
import React from "react";
import { injectIntl, intlShape } from "react-intl";
import ReactModal from "react-modal";
import { connect } from "react-redux";
import { compose } from "redux";
import VM from "scratch-vm";
import scratchlogo from "../components/menu-bar/scratch-logo.svg"
import orientationlogo from "../components/menu-bar/icon--orientation.svg"

import ErrorBoundaryHOC from "../lib/error-boundary-hoc.jsx";
import {
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX,
    // STAGE_TAB_INDEX,
    activateTab,
} from "../reducers/editor-tab";
import { getIsError, getIsShowingProject } from "../reducers/project-state";

import {
    closeBackdropLibrary,
    closeCostumeLibrary,
    closeTelemetryModal,
    openExtensionLibrary,
} from "../reducers/modals";

import cloudManagerHOC from "../lib/cloud-manager-hoc.jsx";
import FontLoaderHOC from "../lib/font-loader-hoc.jsx";
import LocalizationHOC from "../lib/localization-hoc.jsx";
import ProjectFetcherHOC from "../lib/project-fetcher-hoc.jsx";
import ProjectSaverHOC from "../lib/project-saver-hoc.jsx";
import QueryParserHOC from "../lib/query-parser-hoc.jsx";
import SBFileUploaderHOC from "../lib/sb-file-uploader-hoc.jsx";
import storage from "../lib/storage";
import systemPreferencesHOC from "../lib/system-preferences-hoc.jsx";
import TitledHOC from "../lib/titled-hoc.jsx";
import vmListenerHOC from "../lib/vm-listener-hoc.jsx";
import vmManagerHOC from "../lib/vm-manager-hoc.jsx";

import GUIComponent from "../components/gui-one/gui.jsx";
import { setIsScratchDesktop } from "../lib/isScratchDesktop.js";

import OrientationHOC from "../lib/orientation-hoc.jsx";

const { RequestMetadata, setMetadata, unsetMetadata } = storage.scratchFetch;

const setProjectIdMetadata = (projectId) => {
    // If project ID is '0' or zero, it's not a real project ID. In that case, remove the project ID metadata.
    // Same if it's null undefined.
    if (projectId && projectId !== "0") {
        setMetadata(RequestMetadata.ProjectId, projectId);
    } else {
        unsetMetadata(RequestMetadata.ProjectId);
    }
};

class GUI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showStage: false, // Move showStage state here
        };
        this.handleShowStageWrapper = this.handleShowStageWrapper.bind(this);
        this.handleCloseStageWrapper = this.handleCloseStageWrapper.bind(this);
    }

    // Functions to handle the stage visibility
    handleShowStageWrapper() {
        this.setState({ showStage: true });
    }

    handleCloseStageWrapper() {
        this.setState({ showStage: false });
    }

    componentDidMount() {
        setIsScratchDesktop(this.props.isScratchDesktop);
        this.props.onStorageInit(storage);
        this.props.onVmInit(this.props.vm);
        setProjectIdMetadata(this.props.projectId);

        // console.log("props in gui container",this.props);
    }
    componentDidUpdate(prevProps) {
       console.log('gui container did update');

        if (this.props.projectId !== prevProps.projectId) {
            if (this.props.projectId !== null) {
                this.props.onUpdateProjectId(this.props.projectId);
            }
            setProjectIdMetadata(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }
    }
    render() {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`
            );
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            orientation,
            mobileView,
            ...componentProps
        } = this.props;
        console.log("props in gui container", this.props);
        // console.log(orientation )
        // console.log(mobileView)
        if (orientation === "portrait") {
            return (
                <div style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: '#dbffdb'
                }}>
                    {/* Navbar */}
                    <div style={{
                        width: '100%',
                        padding: '1rem',
                        backgroundColor: '#59c059',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                            <img src={scratchlogo} alt="monitor" style={{ width: '5rem', height: '1.5rem'}} />
                    
                            <img src={scratchlogo} alt="rotate" style={{ width: '5rem', height: '1.5rem', paddingRight: '1.5rem' }} />
                       
                    </div>
        
                    {/* Main Content */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        padding: '1rem'
                    }}>
                        <img src={orientationlogo} alt="icon" style={{ width: '6rem', height: '6rem', marginBottom: '1rem' }} />
                        
                        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>Welcome to AILAB</h1>
                        <p style={{ fontSize: '1.25rem' }}>Please switch to landscape mode to enter the AILAB</p>
                    </div>
                </div>
            );
        }
        
        

        return (
            <GUIComponent
                showStage={this.state.showStage}
                handleShowStageWrapper={this.handleShowStageWrapper}
                handleCloseStageWrapper={this.handleCloseStageWrapper}
                loading={fetchingProject || isLoading || loadingStateVisible}
                mobileView={mobileView}
                orientation={orientation}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

// console.log('props in gui container', this.props);

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
};

GUI.defaultProps = {
    isScratchDesktop: false,
    isTotallyNormal: false,
    onStorageInit: (storageInstance) =>
        storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => {},
    onUpdateProjectId: () => {},
    onVmInit: (/* vm */) => {},
};

const mapStateToProps = (state) => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible:
            state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible:
            state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible:
            state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        // stageTabVisible: 
        //     state.scratchGui.editorTab.activeTabIndex === STAGE_TAB_INDEX,
        targetIsStage:
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id ===
                state.scratchGui.targets.editingTarget,
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: (tab) => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    // onActivateStageTab: () => dispatch(activateTab(STAGE_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal()),
});

const ConnectedGUI = injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GUI)
);

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    OrientationHOC,
    LocalizationHOC,
    ErrorBoundaryHOC("Top Level App"),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    SBFileUploaderHOC,
    cloudManagerHOC,
    systemPreferencesHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;